<template>
    <div class="shipper-company-profile-wrapper">
      <b-loading :active="isFetching" />

      <h2 class="title">
        {{ details.companyName }}
      </h2>

      <template v-if="!isFetching">
        <div class="columns is-multiline">
          <div class="column is-half">
            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Company Information
                </p>
              </div>
              <div class="card-content content">
                <dl class="floated-list">
                  <dt>Company Name</dt>
                  <dd>{{ details.companyName }}</dd>

                  <dt>Industry</dt>
                  <dd>{{ details.companyIndustry }}</dd>

                  <dt>Phone Number</dt>
                  <dd>{{ phoneNumber }}</dd>

                  <dt>Tax ID (EIN)</dt>
                  <dd>{{ details.companyTaxId }}</dd>

                  <dt>DUNS number</dt>
                  <dd>{{ details.companyDunAndBradStreetNumber }}</dd>
                </dl>
                <div class="is-clearfix"></div>
              </div>
            </div>


            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Primary Contact
                </p>
              </div>
              <div class="card-content content">
                <dl class="floated-list">
                  <dt>Name</dt>
                  <dd>{{ adminUser.accountFirstName }} {{ adminUser.accountLastName }}</dd>

                  <dt>Email</dt>
                  <dd>
                    <a :href="`mailto:${adminUser.accountEmailAddress}`">{{ adminUser.accountEmailAddress }}</a>
                  </dd>

                  <dt>Phone</dt>
                  <dd>{{ adminUser.phoneNumber }}</dd>
                </dl>
                <div class="is-clearfix"></div>
              </div>
            </div>
          </div>

          <div class="column is-half">
            <div class="card">
              <div class="card-header">
                <p class="card-header-title">
                  Address
                </p>
              </div>
              <div class="card-content content">
                <div v-for="address in details.companyAddresses" :key="address.companyAddressKey" class="floated-list">
                  {{ address.companyAddressStreet1 }}
                  <br/>
                  <template v-if="address.companyAddressStreet2">
                  {{ address.companyAddressStreet2 }}
                  <br/>
                  </template>
                  {{ address.companyAddressCity }}, {{ address.companyAddressState }} {{ address.companyAddressZip }}
                  <hr />

                </div>
                <div class="is-clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>

</template>

<script>
/**
 * First Name
 * Last Name
 * Driver Licenses No.
 * Birth Date
 * MC/DOT Number
 * Phone Number
 * Email
 *
 * Equipment
 *  Truck make & model
 *  build year
 *  trailer type
 *  another trailer type
 *
 *  Insurance
 *  Issuer Name
 *  Policy Number
 *  Effice Date
 *  Active/Inactive
 *
 *
 */

import CompanyApi from '@/api-interface/company'
import DocumentLibrary from '@/components/CompanyDocumentsTable/index'
import CarrierFileUploads from '@/lookup-data/carrier-file-uploads'
import { formatPhoneNumber } from '@/helpers/phoneNumberFormatter'
// import { sortBy } from 'lodash-es'
import { last } from 'lodash-es'

export default {
  name: 'ShipperCompanyProfile',

  data() {
    return {
      documentList: CarrierFileUploads,
      companyAccounts: [],
      companyKey: null,
      isFetching: false,
      showError: false,
      rawDetails: {
        carrier: {}
      }
    }
  },

  async created() {
    this.companyKey = this.$route.params.companyKey
    this.isFetching = true
    try {
      const [companyAccounts, companyInfo] = await Promise.all([
        CompanyApi.getCompanyUsers(this.companyKey),
        CompanyApi.getDetails(this.companyKey)
      ])

      this.rawDetails = companyInfo
      this.companyAccounts = companyAccounts
    } catch (error) {
      console.error(`Error fetching company details ${this.companyKey} `, error)
      this.showError = true
    } finally {
      this.isFetching = false
    }
  },

  computed: {
    sortedCompanyAccounts() {
      // return sortBy(this.companyAccounts, '_createdTimestamp') || []
      return this.companyAccounts || []
    },

    /**
     *
     * @returns {*}
     */
    adminUser() {
      // assume the first sorted user is the admin
      // return this.sortedCompanyAccounts[0]
      const admin = last(this.sortedCompanyAccounts)

      admin.phoneNumber = admin.accountPhones ? admin.accountPhones[0].accountPhoneDigits : ''
      admin.phoneNumber = formatPhoneNumber(admin.phoneNumber)
      return admin
    },

    details() {
      const rawDetails = this.rawDetails
      return {
        ...rawDetails,
        // grab the first address and keep it as an array, so that we can future proof stuff for multi-address
        companyAddresses: [this.rawDetails.companyAddresses ? this.rawDetails.companyAddresses[0] : {}]
      }
    },

    phoneNumber() {
      let phone = this.rawDetails.companyPhones[0] ? this.rawDetails.companyPhones[0].companyPhoneDigits : ''

      return formatPhoneNumber(phone)
    }
  },

  components: {
    DocumentLibrary
  }
}
</script>

<style scoped lang="scss">
.shipper-company-profile-wrapper {
  min-height: 75vh;
  &::after {
    // TODO: this would be great as a mix-in
    content: '';
    background-image: url('../assets/backgrounds/dieter-de-vroomen-383777-unsplash.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    opacity: 0.4;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
    z-index: -1;
  }
}

.card {
  min-height: 200px;
  margin-bottom: 25px;
}
</style>
